import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}


const __default__ = {
    name: "DialogOfOperatorTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    operator: {},
    canViewChatsWithOtherOperators: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(__props.operator.fio) + " ", 1),
    (__props.canViewChatsWithOtherOperators)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Кликните для того, чтобы посмотреть активные диалоги этого оператора "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})